export default "__VITE_ASSET__mT9$65rc__"